var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5294 13.2308C10.7412 12.2115 11.2706 11.4981 12.1176 10.6827C13.1765 9.76538 13.7059 8.44038 13.7059 7.11538C13.7059 5.49348 13.0366 3.93801 11.8451 2.79115C10.6537 1.6443 9.03785 1 7.35294 1C5.66804 1 4.05214 1.6443 2.86073 2.79115C1.66933 3.93801 1 5.49348 1 7.11538C1 8.13462 1.21176 9.35769 2.58824 10.6827C3.32941 11.3962 3.96471 12.2115 4.17647 13.2308M4.17647 17.3077H10.5294M5.23529 21.3846H9.47059",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon5.d0a900d0f51c096b6999f7c482dc0ade.svg";
export { ForwardRef as ReactComponent };